module.exports = __webpack_public_path__ + "static/img/test3.c0b6e967.png";